<template>
  <div>
    <Money
      v-model="value"
      :name="name"
      :id="id"
      :placeholder="placeholder"
      :options="currencyOptions"
      :class="[' form-control form-control-lg py-3 border border-dark-50', state]"
      v-bind="$attrs"
      @blur="onBlur"
    />

    <Errors v-if="errorMessage" :errors="[errorMessage]" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative, Prop, Setup, Model } from 'vue-facing-decorator'
import { useField } from 'vee-validate'
import Money from './Money.vue'
import Errors from './Errors.vue'
import { CurrencyDisplay } from 'vue-currency-input'

@Component({
  components: {
    Money,
    Errors,
  },
  emits: ['update:modelValue','blur','change'],
})
class MoneyField extends Vue {
  @Model({ type: [Number, String] })
  readonly value!: number | string

  @Prop({ type: String, required: true }) readonly name!: string
  @Prop({ type: [String, Object] }) readonly rules!: string | object
  @Prop({ type: String }) readonly id?: string
  @Prop({ type: String, default: '0.00' }) readonly placeholder!: string
  @Prop({ type: String, default: 'NGN' }) readonly currency!: string
  @Prop({ type: String, default: 'en-NG' }) readonly locale!: string

  @Setup((props) => useField<number>(props.name, props.rules, {
    initialValue: props.modelValue,
    validateOnValueUpdate: true,
    syncVModel: true
  }))
  readonly field!: ReturnType<typeof useField>

  get errorMessage(): string | undefined {
    return this.field?.errorMessage?.value
  }

  get state(): string {
    if (!this.field.meta.dirty) return ''
    return this.field.meta.valid ? 'is-valid' : 'is-invalid'
  }

  onBlur() {
    this.field.handleBlur()
  }

    get currencyOptions() {
    return {
      currency: this.currency,      // e.g. 'NGN'
      locale: this.locale,          // e.g. 'en-NG'
      CurrencyDisplay: 'symbol',
      accountingSign:true,
      precision: 2,                 // always show 2 decimals
      valueAsInteger: false,       // interpret typed value as decimal (e.g., 4000 = 4000.00)
      autoDecimalDigits: true,     // automatically add decimals as user types
      hideCurrencySymbolOnFocus: false,   // show ₦ or currency symbol (optional)
      distractionFree: false,      // show full formatting while typing
      useGrouping: true,           // adds commas or locale separatorsfa
      hideGroupingSeparatorOnFocus: false
    }
  }
}

export default toNative(MoneyField)
</script>
